// src/pages/inquiries/UserPurchaseRequest.tsx
import React, {useState, CSSProperties } from 'react';
import {collection, addDoc } from 'firebase/firestore';
import {db } from '../../firebase'; // Ensure correct path

// Simple CSS styles for the page, explicitly typed
const styles: {[key: string]: CSSProperties } = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: 'auto',
    fontFamily: 'Arial, sans-serif',
  },
  form: {
    display: 'flex',
    flexDirection: 'column', // Corrected by adding CSSProperties type
    gap: '1rem',
  },
  input: {
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  textarea: {
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    minHeight: '100px',
  },
  button: {
    padding: '0.75rem',
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  status: {
    marginTop: '1rem',
    padding: '0.75rem',
    borderRadius: '4px',
    textAlign: 'center', // Corrected by adding CSSProperties type
  },
  success: {
    backgroundColor: '#d4edda',
    color: '#155724',
  },
  error: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
  },
};

const UserPurchaseRequest = () => {
  const [itemName, setItemName] = useState('');
  const [description, setDescription] = useState('');
  const [budget, setBudget] = useState('');
  const [contactInfo, setContactInfo] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const requestData = {
        itemName,
        description,
        budget: parseFloat(budget),
        contactInfo,
        status: 'Pending', // Initial status
        submittedAt: new Date(),
      };

      await addDoc(collection(db, 'purchaseRequests'), requestData);
      setStatus('Your purchase request has been submitted successfully. ✅');
      
      // Reset form
      setItemName('');
      setDescription('');
      setBudget('');
      setContactInfo('');
    } catch (error) {
      console.error('Error submitting form:', error);
      setStatus('An error occurred. Please try again. ❌');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2>Request an Item from GREMA Administration</h2>
      <p>Let us know what you want, and we will get it for you.</p>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="text"
          placeholder="Item you are looking for (e.g., 3-Bedroom House)"
          value={itemName}
          onChange={(e) => setItemName(e.target.value)}
          style={styles.input}
          required
        />
        <textarea
          placeholder="Specific details or preferences (e.g., must have a garage, in Kampala)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={styles.textarea}
          required
        />
        <input
          type="number"
          placeholder="Your Budget (optional)"
          value={budget}
          onChange={(e) => setBudget(e.target.value)}
          style={styles.input}
        />
        <input
          type="text"
          placeholder="Your Contact Info (e.g., Email or Phone)"
          value={contactInfo}
          onChange={(e) => setContactInfo(e.target.value)}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? 'Submitting...' : 'Submit Request'}
        </button>
      </form>
      {status && <p style={status.includes('✅') ? {...styles.status, ...styles.success } : {...styles.status, ...styles.error }}>{status}</p>}
    </div>
  );
};

export default UserPurchaseRequest;